/**
 * Compact mono-friendly age: "6H AGO", "2D AGO", "3W AGO", "JUST NOW".
 * Used in kickers so every timestamp in the app reads the same way.
 */
export function formatAge(input: string | Date | undefined | null): string {
  if (!input) return '';
  const date = input instanceof Date ? input : new Date(input);
  const ms = Date.now() - date.getTime();
  if (Number.isNaN(ms)) return '';

  const minutes = Math.floor(ms / 60000);
  if (minutes < 1) return 'JUST NOW';
  if (minutes < 60) return `${minutes}M AGO`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}H AGO`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}D AGO`;

  const weeks = Math.floor(days / 7);
  if (weeks < 8) return `${weeks}W AGO`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months}MO AGO`;

  return `${Math.floor(days / 365)}Y AGO`;
}

/** Lab stamp: № 001 */
export function stamp(index: number): string {
  return `№ ${String(index + 1).padStart(3, '0')}`;
}
